// Inbox and voucher catalog (Norwegian).
window.PlummeI18n.register('no', {
  'voucher.none': 'Ingen bilag',
  'voucher.noLedgerLines': 'Ingen hovedbokslinjer tilgjengelig fra backend ennå.',
  'voucher.noLedger': 'Ingen hovedbokslinjer',
  'voucher.action': 'Handling',
  'voucher.title': 'Transaksjoner',
  'voucher.incompleteBasis': 'Journaldekningen er ufullstendig. Listen kan brukes til dokumentoppslag, men må ikke leses som en komplett hovedbok eller bilagsliste.',
  'voucher.journalLoading': 'Regnskapsjournalen hentes. Bilagene vises når den er lest.',
  'voucher.subtitle': 'Alle bokførte transaksjoner for regnskapsåret',
  'voucher.backToVat': 'Tilbake til MVA-meldingen',
  'voucher.showAll': 'Vis alle transaksjoner',
  'voucher.download': 'Last ned',
  'voucher.loadingPreview': 'Laster forhåndsvisning...',
  'voucher.cannotPreviewUse': 'Filen kan ikke forhåndsvises her. Bruk Last ned når du vil åpne den.',
  'voucher.cannotPreview': 'Denne filtypen kan ikke forhåndsvises her.',
  'voucher.invoice': 'Faktura',
  'voucher.voucher': 'Bilag',
  'voucher.attachmentAttached': 'Bilag vedlagt',
  'voucher.commentOptional': 'Kommentar (valgfritt)',
  'voucher.commentPh': 'F.eks. feilført beløp, dobbeltføring eller feil leverandør.',
  'voucher.view': 'Visning',
  'voucher.viewHelp': 'Bytt mellom bilagsliste, detaljerte posteringer og hovedbok gruppert per konto.',
  'voucher.view.bilag': 'Bilag',
  'voucher.view.detaljer': 'Detaljer',
  'voucher.view.hovedbok': 'Hovedbok',
  'voucher.searchPh': 'Søk på bilag, konto eller beløp',
  'voucher.searchHelp': 'Søk på bilagsnummer, motpart, konto/postering eller beløp. I hovedbok kan du også søke på debet, kredit og saldo.',
  'voucher.filterHelp': 'Filtrer bilagene på type, vedlegg, betalingsstatus, periode og beløp.',
  'voucher.amountTitle': 'Beløp på bilaget',
  'voucher.amountHelp': 'Netto er beløpet uten MVA (selve kostnaden/inntekten), MVA er avgiften, og brutto er totalbeløpet inkludert MVA. Sammen med dato og bilagsnummer er dette nøkkelopplysningene i føringen.',
  'voucher.rowHelp': 'Hver rad er ett bilag. Ikonet og merkelappen viser typen (salg, kjøp, leverandørfaktura, kreditnota, manuelt bilag), og du ser navn og bilagsnummer. Trykk på raden for å åpne bilaget.',
  'voucher.net': 'Netto',
  'voucher.netHelp': 'Beløpet uten MVA - selve kostnaden eller inntekten som bokføres på konto.',
  'voucher.vat': 'MVA',
  'voucher.vatHelp': 'Merverdiavgiften på bilaget - utgående MVA på salg, inngående (fradragsberettiget) MVA på kjøp.',
  'voucher.gross': 'Brutto',
  'voucher.totalAmount': 'Totalbeløp',
  'voucher.grossHelp': 'Totalbeløpet inkludert MVA - netto pluss MVA. Dette er beløpet som faktisk betales eller mottas.',
  'voucher.accountPh': 'F.eks. programvare, bank eller 6300',
  'voucher.account': 'Konto',
  'voucher.accountHelp': 'Kontoen forteller hva føringen gjelder - hentet fra kontoplanen. Kontonummeret bestemmer hvor beløpet havner i regnskapet (1xxx eiendeler, 2xxx gjeld/egenkapital, 3xxx inntekt, 4-7xxx kostnader). Trykk listeikonet for å søke i kontoplanen.',
  'voucher.pickAccount': 'Velg konto',
  'voucher.searchChart': 'Søk i kontoplanen...',
  'voucher.noDescription': 'Uten beskrivelse',
  'voucher.removeEntry': 'Fjern postering',
  'voucher.entryDate': 'Bilagsdato',
  'voucher.entryDateHelp': 'Datoen føringen skal bokføres på. Den avgjør hvilken regnskaps- og MVA-periode posteringen havner i.',
  'voucher.whatFor': 'Hva gjelder føringen?',
  'voucher.whatForHelp': 'En kort tekst som forklarer hva føringen gjelder. Vises i hovedboken og gjør det lett å forstå posteringen senere.',
  'voucher.fromAccount': 'Fra konto',
  'voucher.toAccount': 'Til konto',
  'voucher.fromAccountCredit': 'Fra konto (kredit)',
  'voucher.fromAccountHelp': 'Kontoen pengene går FRA - kreditsiden av føringen. Betaler du f.eks. husleie fra bankkontoen, er banken (1920) «Fra». Kredit reduserer en eiendel eller øker gjeld/inntekt.',
  'voucher.vatCode': 'MVA-kode',
  'voucher.vatCodeHelp': 'Avgiftskoden styrer hvordan MVA beregnes og rapporteres på mva-meldingen. Kode 86 brukes for fjernleverbare tjenester fra utlandet. Vareimport registreres via tolldeklarasjonen.',
  'voucher.swap': 'Bytt Fra og Til',
  'voucher.swapHelp': 'Bytter om på Fra- og Til-kontoen på linjen. Nyttig hvis du har ført debet og kredit motsatt vei.',
  'voucher.toAccountDebit': 'Til konto (debet)',
  'voucher.toAccountHelp': 'Kontoen pengene går TIL - debetsiden av føringen. Gjelder føringen husleie, er husleiekontoen (6300) «Til». Debet øker en kostnad eller eiendel.',
  'voucher.addLineHelp': 'Legger til en ny føringslinje i denne posteringen. Bruk flere linjer når beløpet skal fordeles på flere kontoer - alle linjene må til sammen gjøre at debet og kredit går opp i null.',
  'voucher.attachHelp': 'Legg ved dokumentasjon på føringen - kvittering, faktura eller annet bilag. Valgfritt, men anbefalt: god dokumentasjon gjør regnskapet etterprøvbart. Du kan dra inn filer eller lime inn et skjermbilde.',
  'voucher.attachOptional': 'Vedlegg (valgfritt)',
  'voucher.uploadAttachment': 'Last opp vedlegg',
  'voucher.deleteAttachment': 'Slett vedlegg',
  'voucher.openNewTab': 'Åpne i ny fane',
  'voucher.balance': 'Balanse',
  'voucher.balanceHelp': 'Viser om posteringen går opp. «Balansert» betyr at sum Til (debet) er lik sum Fra (kredit) - da kan føringen registreres. Er det en differanse, må du rette beløpene så de går opp i null.',
  'voucher.toDebit': 'Til (debet)',
  'voucher.fromCredit': 'Fra (kredit)',
  'voucher.posted': 'Bokført',
  'voucher.edit': 'Rediger',
  'voucher.newCopy': 'Ny kopi av fri postering',
  'voucher.newFree': 'Ny fri postering',
  'voucher.from': 'Fra',
  'voucher.to': 'Til',
  'voucher.sum': 'Sum',
  'voucher.newEntry': 'Ny postering',
  'voucher.newEntryHelp': 'Legger til enda en postering (et nytt bilag) under den samme registreringen. Hver postering har egen dato, beskrivelse og linjer, og bokføres som sitt eget bilag.',
  'voucher.postHelp': 'Bokfører posteringen(e) i regnskapet. Knappen er aktiv først når alle posteringer er balansert - altså at debet og kredit går opp i null.',
  'voucher.details': 'Detaljer',
  'voucher.statusBalanced': 'Balansert',
  'voucher.statusMissingAccount': 'Mangler konto',
  'voucher.statusSameAccount': 'Samme konto',
  'voucher.statusEmpty': 'Tom',
  'voucher.statusUnbalanced': 'Ubalansert',
  'voucher.attachDropHint': 'Dra og slipp filer hit, eller lim inn skjermbilde med Ctrl+V',
  'voucher.chooseBothAccounts': 'Velg både fra- og tilkonto.',
  'voucher.sameAccountWarning': 'Fra- og tilkonto kan ikke være samme konto.',
  'voucher.balancedReady': 'Balansert - klar til å registrere',
  'voucher.enterAmount': 'Legg inn et beløp.',
  'voucher.difference': 'Differanse: {amount}',
  'voucher.postedTitlePlural': 'Føringer registrert',
  'voucher.postedTitleSingular': 'Føring registrert',
  'voucher.postedBodyPlural': '{count} posteringer er bokført.',
  'voucher.postedBodySingular': 'Posteringen er bokført.',
  'voucher.postedIntro': 'Slik ble det ført:',
  'voucher.descriptionRequired': 'Legg inn beskrivelse på alle posteringer før du bokfører.',
  'voucher.saveFailed': 'Kunne ikke registrere føringen.',
  'voucher.backTo': 'Tilbake til {label}',
  'voucher.controlPoint': 'kontrollpunktet',
  'voucher.editTitle': 'Rediger fri postering',
  'voucher.freePosting': 'Fri postering',
  'voucher.editSubtitle': 'Oppdater posteringen og lagre endringene i backend.',
  'voucher.correctPostedTitle': 'Korriger bokført bilag',
  'voucher.correctPostedSubtitle': 'Originalen beholdes. Plumme bokfører en reversering og et nytt erstatningsbilag i én operasjon.',
  'voucher.correctPostedNotice': 'Det opprinnelige bilaget og journalnummeret endres ikke. Endringen blir en koblet reversering og erstatning.',
  'voucher.correctionReason': 'Årsak til korrigering',
  'voucher.correctionReasonPlaceholder': 'Beskriv hva som var feil og hvorfor bilaget korrigeres',
  'voucher.correctPostedAction': 'Korriger bilag',
  'voucher.correctionPreview': 'Forhåndsvis korrigering',
  'voucher.correctionOriginal': 'Original',
  'voucher.correctionReversal': 'Eksakt reversering',
  'voucher.correctionReplacement': 'Erstatningsbilag',
  'voucher.freePostingSubtitle': 'Manuelle føringer - debet og kredit må gå opp i null',
  'voucher.freePostingTitleHelp': 'Fri postering lar deg bokføre manuelt rett på konto når du trenger full kontroll - for eksempel rettelser, omposteringer eller føringer som ikke passer i et vanlig kjøp eller salg. Du styrer selv hvilke kontoer beløpet flyttes mellom.',
  'voucher.directVatWarningTitle': 'Advarsel: direkteføring på MVA-konto',
  'voucher.directVatWarningBody': 'Disse posteringene blir bokført i hovedboken, men blir ikke med i MVA-meldingen. Bruk ordinært kjøp, salg eller tolldeklarasjon når beløpet skal rapporteres som MVA.',
  'voucher.directVatExcluded': 'ikke med i MVA-meldingen',
  'voucher.directVatConfirmLabel': 'Skriv OK for å bekrefte at du forstår konsekvensen',
  'voucher.directVatConfirmValue': 'OK',
  'voucher.registerEntriesPlural': 'Registrer føringer',
  'voucher.registerEntrySingular': 'Registrer føring',
  'voucher.registering': 'Registrerer...',
  'voucher.creditWord': 'kredit',
  'voucher.debitWord': 'debet',
  'voucher.attachmentFallbackName': 'vedlegg',
  'inbox.prevPage': 'Forrige side',
  'inbox.page': 'Side',
  'inbox.nextPage': 'Neste side',
  'inbox.zoomOut': 'Zoom ut',
  'inbox.zoomIn': 'Zoom inn',
  'inbox.rotate': 'Roter bilag',
  'inbox.mainDoc': 'Hovedbilag',
  'inbox.moveTo': 'Flytt til',
  'inbox.payOperating': 'Driftskonto - 1920',
  'inbox.payCash': 'Kontant - 1900',
  'inbox.payPrivate': 'Privat utlegg',
  'inbox.payUnknown': 'Velg betalingskilde ...',
  'inbox.suggestion': 'Forslag fra SuperPlumma',
  'inbox.docType': 'Type bilag',
  'inbox.quickChoices': 'Hurtigvalg',
  'inbox.quickChoiceUse': 'Velg hva hurtigvalget skal erstatte',
  'inbox.quickChoiceRemembered': 'Husket fra {count} tidligere bilag hos leverandøren.',
  'inbox.quickChoiceAccount': 'Erstatt konto',
  'inbox.quickChoiceDescription': 'Erstatt beskrivelse',
  'inbox.quickChoiceBoth': 'Erstatt begge',
  'inbox.purchase': 'Kjøp',
  'inbox.supplierInvoice': 'Leverandørfaktura',
  'inbox.pickSupplier': 'Velg leverandør',
  'inbox.invoiceNoPh': 'F.eks. 0012345',
  'inbox.toggleVatHelp': 'Trykk for å bytte om beløpet du skriver inn er uten MVA eller med MVA. Plumme regner om automatisk og lagrer brutto beløp på bilagsforslaget.',
  'inbox.vatDeductionRate': 'Foreslått MVA-fradrag',
  'inbox.documentVatRateHint': 'Bilaget viser {documentRate} % MVA. Forslaget bruker {deductionRate} % fradrag ut fra foretakets MVA-status og valgt behandling.',
  'inbox.accountCategory': 'Konto/kategori',
  'inbox.accountHelp': 'SuperPlummas forslag er forhåndsvalgt. Trykk for å velge en annen konto.',
  'inbox.dueDateFromReceipt': 'Bilaget har ingen forfallsdato. Satt lik bilagsdato.',
  'inbox.supplierNotSaved': 'Velg en lagret leverandør, eller lagre leverandøren før du bokfører fakturaen.',
  'err.purchase.supplierNotSaved': 'Velg en lagret leverandør, eller lagre leverandøren før du bokfører fakturaen.',
  'inbox.duplicateTitle': 'Mulig dobbelføring',
  'inbox.duplicateBody': 'Et bilag med samme dato og beløp er allerede bokført.',
  'inbox.duplicateSameSupplier': 'Et bilag med samme dato, beløp og leverandør er allerede bokført.',
  'inbox.duplicateUploadFile': 'Mulig dobbeltopplasting: nøyaktig samme fil ligger allerede i innboksen.',
  'inbox.duplicateUploadContent': 'Mulig dobbeltopplasting: samme leverandør og beløp som et annet bilag i innboksen, og bilagsdatoene er innenfor 7 dager.',
  'inbox.duplicateUploadCount': 'Gjelder {count} andre bilag.',
  'inbox.setPaymentSource': 'Betalt fra',
  'inbox.bulkPaymentTitle': 'Betalt fra',
  'inbox.bulkPaymentLead': 'Kilden settes på {count} bilag. Du kan endre den på hvert enkelt bilag etterpå.',
  'inbox.bulkPaymentLabel': 'Betalt fra',
  'inbox.bulkPaymentHint': 'Bilagene blir klare for bokføring med denne kontoen.',
  'inbox.bulkPaymentPick': 'Velg en betalingskilde først.',
  'inbox.bulkPaymentConfirm': 'Sett på {count} bilag',
  'inbox.bulkPaymentDone': 'Betalingskilde satt på {count} bilag.',
  'inbox.uploadPaymentSingleTitle': 'Betalt fra',
  'inbox.uploadPaymentBulkTitle': 'Fordel betalingskilde',
  'inbox.uploadPaymentAppliesTo': 'Gjelder {count} valgte bilag',
  'inbox.uploadPaymentSelectFirst': 'Merk bilagene under, så setter knappene betalingskilden for dem.',
  'inbox.uploadPaymentBank': 'Bank',
  'inbox.uploadPaymentBankSetup': 'Legg inn bankkonto først',
  'inbox.uploadPaymentOtherSource': 'Velg annen betalingskilde ...',
  'inbox.uploadPaymentOperating': 'Driftskonto',
  'inbox.uploadPaymentPrivate': 'Privat',
  'inbox.uploadPaymentPrivateRecommended': 'Anbefalt uten bedriftskonto',
  'inbox.uploadPaymentAnalyzeShort': 'Superplumma analyserer',
  'inbox.collectionNotice': 'Inkassovarsel',
  'inbox.collectionNoticeTitle': 'Dette hører sammen med originalbilaget',
  'inbox.collectionNoticeBody': 'Hovedkravet skal ikke bokføres eller MVA-føres på nytt. Knytt varselet til originalbilaget; renter og innkrevingskostnader behandles separat uten MVA.',
  'inbox.collectionNoticePrincipal': 'Hovedkrav',
  'inbox.collectionNoticeInterest': 'Renter',
  'inbox.collectionNoticeCosts': 'Innkrevingskostnader',
  'inbox.collectionNoticeCandidates': 'Mulige originalbilag',
  'inbox.collectionNoticeLink': 'Knytt til',
  'inbox.collectionNoticeLinked': 'Inkassovarselet er knyttet til originalbilaget.',
  'inbox.collectionNoticeLinkFailed': 'Kunne ikke knytte inkassovarselet til originalbilaget.',
  'inbox.collectionNoticeOpenOriginal': 'Åpne originalbilaget',
  'inbox.collectionNoticeNoCandidate': 'Fant ikke et sikkert forslag. Finn eller last opp originalfakturaen før varselet behandles.',
  'inbox.collectionNoticeBookBlocked': 'Knytt til originalbilaget før behandling',
  'inbox.uploadPaymentAssigned': 'Konto {account}',
  'inbox.uploadPaymentUnpaid': 'Ikke betalt ennå',
  'inbox.uploadPaymentUnpaidHint': 'For leverandørfaktura som skal stå som gjeld til den betales.',
  'inbox.uploadPaymentAnalyze': 'La Plumme finne betalingskilden',
  'inbox.uploadPaymentUnassigned': 'Ikke avklart',
  'inbox.uploadPaymentSelectVisible': 'Velg viste',
  'inbox.uploadPaymentShowAll': 'Vis alle',
  'inbox.uploadPaymentShowPending': 'Vis bare uavklarte',
  'inbox.uploadPaymentProgress': '{completed} av {count} avklart',
  'inbox.uploadPaymentConfirm': 'Last opp {count}',
  'inbox.uploadPaymentReceipt': 'Bilag',
  'inbox.cardNudgeTitle': '{count} bilag mangler betalingskilde',
  'inbox.cardNudgeText': 'Registrer kortene på bankkontoene, så kjenner Plumme igjen betalingen rett fra kvitteringen. Kontotypen avgjør om kjøpet blir bedrift eller privat utlegg.',
  'inbox.cardNudgeAction': 'Registrer kort',
  'inbox.shortDescription': 'Kort beskrivelse av bilaget',
  'inbox.shrinkPreview': 'Forminsk forhåndsvisning',
  'inbox.growPreview': 'Forstørr forhåndsvisning',
  'inbox.dragWidth': 'Dra for å endre bredde',
  'inbox.sendTo': 'Send til:',
  'inbox.filterStatus': 'Status',
  'inbox.filterBankConnection': 'Bankkobling',
  'inbox.filterReadyToPost': 'Klar for bokføring',
  'inbox.filterNeedsReview': 'Til kontroll',
  'inbox.filterAwaitingAnalysis': 'Venter på analyse',
  'inbox.toInbox': 'Til innboks (bilag)',
  'inbox.toDocumentation': 'Til dokumentasjon',
  'inbox.selectAll': 'Velg alle',
  'inbox.selectHint': 'Shift-klikk for å velge flere på rad',
  'inbox.reviewSelected': 'Start føring ({count})',
  'inbox.planTitle': 'Bokfør med SuperPlumma',
  'inbox.planLead': '{count} av {selected} valgte bilag bokføres nå.',
  'inbox.planNothing': 'Ingen av de valgte bilagene kan bokføres slik de står nå.',
  'inbox.planWithNotes': '{count} med forhåndsvalgt betalingskilde',
  'inbox.planConfirm': 'Bokfør {count} bilag',
  'inbox.planShow': 'Vis',
  'inbox.planHide': 'Skjul',
  'inbox.planSameFile': 'Sperret: nøyaktig samme fil ligger allerede inne ({count})',
  'inbox.planSameInvoiceNumber': 'Sperret: fakturanummeret er allerede registrert ({count})',
  'inbox.planSameContent': 'Hoppes over: mulig dobbeltopplasting ({count})',
  'inbox.planNeedsReview': 'Hoppes over: trenger kontroll ({count})',
  'inbox.planMissingData': 'Hoppes over: mangler data ({count})',
  'inbox.planMissing': 'Hoppes over: finnes ikke lenger ({count})',
  'inbox.planAllowContent': 'Bokfør disse likevel - jeg har sjekket at det er ulike kjøp',
  'inbox.planAllowContentWarn': 'Duplikatene bokføres som separate bilag. Se over at det stemmer før du fortsetter.',
  'inbox.planResultTitle': 'Bokføringen er ferdig',
  'inbox.planResultLead': '{booked} av {selected} valgte bilag ble bokført.',
  'inbox.planBooked': 'Bokført ({count})',
  'inbox.planSkipped': 'Hoppet over ({count})',
  'inbox.planFailed': 'Feilet ({count})',
  'inbox.walkTitle': 'Føring av bilag',
  'inbox.walkLead': '{count} bilag i køen.',
  'inbox.walkReady': 'Klare',
  'inbox.walkNeedsReview': 'Trenger kontroll',
  'inbox.walkDuplicates': 'Mulige duplikater',
  'inbox.walkDuplicateOf': 'Samme som {names}.',
  'inbox.walkHint': 'Du kan lukke når som helst - de du ikke har tatt blir stående valgt.',
  'inbox.walkStart': 'Gå gjennom alle {count}',
  'inbox.walkBookReady': 'Bokfør de {count} klare nå',
  'inbox.walkPosition': '{index} av {total}',
  'inbox.walkPause': 'Fortsett senere',
  'inbox.walkTrash': 'Til papirkurv',
  'inbox.walkSkip': 'Hopp over',
  'inbox.walkNext': 'Neste',
  'inbox.walkGone': 'Bilaget er borte',
  'inbox.walkGoneText': 'Det ble bokført, slettet eller flyttet mens gjennomgangen sto åpen.',
  'inbox.walkDoneTitle': 'Gjennomgangen er ferdig',
  'inbox.walkDoneLead': '{count} bilag gjennomgått',
  'inbox.walkDoneCounts': '{booked} bokført, {skipped} hoppet over, {trashed} flyttet til papirkurv.',
  'inbox.clearSelection': 'Fjern valg',
  'inbox.restoreAll': 'Gjenopprett alle',
  'inbox.deletePermanently': 'Slett permanent',
  'inbox.deleteAll': 'Slett alle',
  'inbox.downloadAll': 'Last ned valgte',
  'inbox.downloading': 'Laster ned...',
  'inbox.postAllWithAi': 'Bokfør alle med SuperPlumma',
  'inbox.postWithAi': 'Bokfør {count} med SuperPlumma',
  'inbox.postNoneReady': 'Ingen av de valgte bilagene er klare for bokføring. Bruk «Start føring» for å ta dem ett om gangen.',
  'inbox.uploadDocument': 'Last opp dokument',
  'inbox.mergeToOne': 'Slå sammen til ett bilag',
  'inbox.dragToMerge': 'Dra for å slå sammen bilag',
  'inbox.restore': 'Gjenopprett',
  'inbox.post': 'Bokfør',
  'inbox.archiveNote': 'Arkiv for dokumenter som ikke skal bokføres som bilag.',
  'inbox.searchDocs': 'Søk i dokumenter...',
  'inbox.moveToTrash': 'Flytt til papirkurv',
  'inbox.defaultVoucherName': 'Bilag',
  'inbox.defaultDocumentName': 'Dokument',
  'inbox.docTypeSettlement': 'Oppgjør',
  'inbox.docTypeSupplierInvoice': 'Leverandørfaktura',
  'inbox.docTypeSaleVoucher': 'Salgsbilag',
  'inbox.docTypePurchaseVoucher': 'Kjøpsbilag',
  'inbox.paySourcePrivate': 'Privat betalt',
  'inbox.paySourceCash': 'Kontant',
  'inbox.paySourceUnclear': 'Uavklart betaling',
  'inbox.paySourceCompany': 'Bedriftskonto',
  'inbox.vatOnDocumentWithDeduction': '{documentRate} % MVA på bilaget · {deductionRate} % fradrag',
  'inbox.vatRateLabel': '{rate} % MVA',
  'inbox.paidFromBank': 'Betalt fra bank',
  'inbox.supplierNotRead': 'Bedrift ikke avlest',
  'inbox.invoiceNumberLabel': 'Faktura {number}',
  'inbox.attachmentLinkMissing': 'Vedlegget mangler tilgjengelig lenke.',
  'inbox.menuNewPurchase': 'Betalt kjøp',
  'inbox.menuFixedAsset': 'Driftsmiddel',
  'inbox.menuOtherSale': 'Annet salg',
  'inbox.menuOpenAttachment': 'Åpne vedlegg',
  'inbox.menuDownload': 'Last ned',
  'inbox.menuSplitAgain': 'Del opp igjen',
  'inbox.reanalyze': 'Reanalyser',
  'inbox.analyze': 'Analyser',
  'inbox.previewDocumentFallback': 'Dokument',
  'inbox.previewMissingFileLink': 'Mangler fil-lenke',
  'inbox.saveNotConnected': 'Lagring av bilagsforslag er ikke koblet til backend.',
  'inbox.suggestionUpdated': 'Bilagsforslaget er oppdatert.',
  'inbox.suggestionSaveFailed': 'Kunne ikke lagre bilagsforslaget.',
  'inbox.settlementFromLabel': 'Oppgjør fra',
  'inbox.settlementFromPh': 'Vipps, Stripe, Klarna ...',
  'inbox.settlementIdLabel': 'Oppgjørs-ID',
  'inbox.settlementNetToBankLabel': 'Netto til bank',
  'inbox.suggestedInvoiceSingular': 'Foreslatt faktura',
  'inbox.suggestedInvoicePlural': 'Flere mulige fakturaer',
  'inbox.selectInvoiceManually': 'Velg faktura manuelt',
  'inbox.paidToggleOn': 'Betalt',
  'inbox.paidToggleOff': 'Ikke betalt – føres som leverandørgjeld',
  'inbox.paidToLabel': 'Betalt til',
  'inbox.projectSaveFailed': 'Kunne ikke lagre prosjektet.',
  'inbox.awaitingOcrData': 'Venter på OCR-data',
  'inbox.showSuggestionAgain': 'Vis forslag igjen',
  'inbox.maximizePreview': 'Maksimer forhåndsvisning',
  'inbox.uploadPartialAnalyzing': '{done} av {total} bilag ble lastet opp. Analyserer de som kom inn ...',
  'inbox.uploadedSingle': 'Bilag lastet opp.',
  'inbox.uploadedMultipleAnalyzing': '{count} bilag lastet opp. Analyserer ...',
  'inbox.uploadFailedSingle': 'Kunne ikke laste opp bilaget.',
  'inbox.uploadFailedMultiple': 'Kunne ikke laste opp bilagene.',
  'inbox.uploadFailedGeneric': 'Kunne ikke laste opp bilag.',
  'inbox.remainingAwaitingAnalysisSuffix': '{count} bilag star igjen som «Venter på analyse».',
  'inbox.uploadedButAnalysisFailedSingle': 'Bilaget ble lastet opp, men analysen feilet.',
  'inbox.uploadedButAnalysisFailedMultiple': 'Bilagene ble lastet opp, men analysen feilet.',
  'inbox.partialAnalysisFailed': '{failed} av {total} bilag ble ikke analysert. Prøv «Analyser» på raden.',
  'inbox.documentAddedSingle': 'Dokument lagt i Dokumentasjon.',
  'inbox.documentAddedMultiple': 'Dokumentene er lagt i Dokumentasjon.',
  'inbox.documentUploadFailed': 'Kunne ikke laste opp dokument.',
  'inbox.analyzed': 'Bilaget er analysert.',
  'inbox.analyzeActionFailed': 'Bilagsanalysen feilet.',
  'inbox.bookedNoneReason': 'Ingen bilag ble bokført.',
  'inbox.bookedSummary': '{booked} bokført, {skipped} hoppet over.',
  'inbox.bookedOne': 'Bilaget er bokført.',
  'inbox.bookedCount': '{count} bilag er bokført.',
  'inbox.bookFailedFallback': 'Kunne ikke bokføre bilagene.',
  'inbox.setPaymentSourceFailed': 'Kunne ikke sette betalingskilden.',
  'inbox.moveToTrashFailed': 'Kunne ikke flytte bilag.',
  'inbox.movedToTrash': 'Bilag flyttet til papirkurv.',
  'inbox.movedToTrashCount': '{count} bilag flyttet til papirkurv.',
  'inbox.restoredOne': 'Bilag gjenopprettet.',
  'inbox.restoredCount': '{count} bilag gjenopprettet.',
  'inbox.restoreFailed': 'Kunne ikke gjenopprette bilag.',
  'inbox.confirmDeletePermanentOne': 'Slette bilaget permanent?',
  'inbox.confirmDeletePermanentMany': 'Slette valgte bilag permanent?',
  'inbox.deletedPermanently': 'Bilag slettet permanent.',
  'inbox.deleteFailed': 'Kunne ikke slette bilag.',
  'inbox.docMovedToTrash': 'Dokument flyttet til papirkurv.',
  'inbox.docMovedToTrashCount': '{count} dokumenter flyttet til papirkurv.',
  'inbox.docMoveToTrashFailed': 'Kunne ikke flytte dokument.',
  'inbox.docRestored': 'Dokument gjenopprettet.',
  'inbox.docRestoredCount': '{count} dokumenter gjenopprettet.',
  'inbox.docRestoreFailed': 'Kunne ikke gjenopprette dokument.',
  'inbox.confirmDeleteDocOne': 'Slette dokumentet permanent?',
  'inbox.confirmDeleteDocMany': 'Slette valgte dokumenter permanent?',
  'inbox.docDeletedPermanently': 'Dokument slettet permanent.',
  'inbox.docDeleteFailed': 'Kunne ikke slette dokument.',
  'inbox.downloadPartial': '{downloaded} av {total} filer ble lastet ned. Resten kunne ikke hentes.',
  'inbox.downloadedZip': '{count} filer lastet ned som zip.',
  'inbox.downloadedSingleFile': 'Filen er lastet ned.',
  'inbox.downloadFilesFailed': 'Kunne ikke laste ned filene.',
  'inbox.movedToDocs': 'Bilag flyttet til Dokumentasjon.',
  'inbox.movedToDocsCount': '{count} bilag flyttet til Dokumentasjon.',
  'inbox.moveToDocsFailed': 'Kunne ikke flytte bilag til Dokumentasjon.',
  'inbox.mergedCount': '{count} bilag slått sammen.',
  'inbox.mergeFailed': 'Kunne ikke slå sammen bilag.',
  'inbox.splitAgainDone': 'Bilaget er delt opp igjen.',
  'inbox.splitAgainFailed': 'Kunne ikke dele opp bilag.',
  'inbox.addressCopied': 'Bilagsadresse kopiert.',
  'inbox.trashTitle': 'Søppelkasse',
  'inbox.docsSubtitle': 'Arkiv for avtaler, kontrakter og dokumenter - ikke bilag til bokføring.',
  'inbox.inboxSubtitle': 'Last opp eller videresend bilag på e-post - vi leser av det vi kan.',
  'inbox.titleHelp': 'Innboksen er samlestedet for bilag som er kommet inn, men ikke bokført ennå. Last opp filer eller videresend kvitteringer og fakturaer på e-post - SuperPlumma leser av innholdet og gjør dem klare for bokføring.',
  'inbox.docsWithCount': 'Dokumentasjon ({count})',
  'inbox.trashWithCount': 'Søppelkasse ({count})',
  'inbox.inboxWithCount': 'Innboks ({count})',
  'inbox.wordDocuments': 'dokumenter',
  'inbox.wordVouchers': 'bilag',
  'inbox.emptyDocsTitle': 'Ingen dokumenter',
  'inbox.emptyTrashTitle': 'Papirkurven er tom',
  'inbox.emptyDocsText': 'Last opp avtaler, kontrakter og dokumenter her.',
  'inbox.searchDocsFull': 'Søk i dokumenter - filnavn, type...',
  'inbox.vehicleCostReminderDefault': 'Kun dersom foretaket eier eller leaser kjøretøy.',
});
